import React, { useCallback, useState, useEffect, useContext, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import PureImage from './PureImage';
import FilterImage from './FilterImage';
import Video from './Video';
import Droppable from '../DnD/Droppable';
import { designActions } from '../../actions';
import _ from 'lodash';
import './VImage.css';
import { DesignContext } from '../../containers/GraphicBuilder/GraphicBuilder';
import { generateImageLink } from '../../utils/design.utils';

const Media = props => {
  const dispatch = useDispatch();
  const { activePageRef } = useContext(DesignContext);
  // let entity = useSelector(state => state.design.entitiesState[props.entityId], []);
  const authToken = useSelector(state => state.authentication.user.authToken);
  const imageColorsState = useSelector(state => state.design.imageColorsState);
  let entity;
  const entityInBg = useSelector(state => _.get(state.design.pages[activePageRef.current], 'background'));
  const entityById = useSelector(state => state.design.entitiesState[props.entityId]);
  if (props.entityId === -1) {
    entity = {
      src: _.get(entityInBg, 'media.src'),
      type: _.get(entityInBg, 'media.type'),
      data: _.get(entityInBg, 'media.data'),
      style: _.get(entityInBg, 'style'),
    };
  } else {
    entity = entityById;
  }
  if (props.internal && props.entityId !== -1) {
    if (props.area) {
      const entityFromMedias = _.get(entity, 'data.medias');
      entity = entityFromMedias && entityFromMedias[props.area];
      console.log('-----> has area', entity);
    } else {
      entity = _.get(entity, 'data.medias');
    }
  }

  const [mediaSize, setMediaSize] = useState();
  const [imageLoaded, setImageLoaded] = useState(true);
  const thumbnailRef = useRef(null);
  const type = props.type ? props.type : _.get(entity, 'type');
  let src = props.src ? props.src : _.get(entity, 'src');
  const authenticatedSrc = generateImageLink(src, authToken);
  const frameSrc = _.get(entity, 'frame.src');
  // src = src.includes('authToken') ? src : `${src}?authToken=${authToken}`;
  const [oldSrc, setOldSrc] = useState(src);

  const calculateSize = useCallback(() => {
    if ((!props.parentSize && !props.internal) || props.background) {
      setMediaSize(null);
      return;
    }

    const targetParent = document.getElementById(`E${props.dataTarget}`);
    if (!targetParent) return;

    const target = targetParent.querySelector('img');
    const imageWidth = _.get(target, 'naturalWidth');
    const imageHeight = _.get(target, 'naturalHeight');
    const imageRatio = imageWidth / imageHeight;
    let parentWidth = parseFloat(_.get(props.parentSize, 'width'));
    let parentHeight = parseFloat(_.get(props.parentSize, 'height'));
    if (!imageRatio) {
      setMediaSize({ width: `${parentWidth}px`, height: `${parentHeight}px` });
    } else {
      let newWidth, newHeight;
      if (parentWidth > parentHeight) {
        newWidth = parentWidth;
        newHeight = parentWidth / imageRatio;
        if (parentHeight > newHeight) {
          newWidth = parentHeight * imageRatio;
          newHeight = parentHeight;
        }
      } else {
        newWidth = parentHeight * imageRatio;
        newHeight = parentHeight;
        if (parentWidth > newWidth) {
          newWidth = parentWidth;
          newHeight = parentWidth / imageRatio;
        }
      }
      setMediaSize({ width: `${newWidth}px`, height: `${newHeight}px` });
    }
  }, [props.background, props.dataTarget, props.internal, props.parentSize]);

  useEffect(() => {
    const imageTarget = document.getElementById(`E${props.dataTarget}`);
    if (props.internal && imageTarget && !imageTarget.style.width) {
      calculateSize();
    }
  }, [calculateSize, props.dataTarget, props.internal]);

  useEffect(() => {
    if (props.internal && props.src !== frameSrc) {
      thumbnailRef.current && (thumbnailRef.current.style.display = 'block');
      if (src !== oldSrc) {
        const imageTarget = document.getElementById(`E${props.dataTarget}`);
        if (imageTarget) imageTarget.style.cssText = '';
        calculateSize();
        setOldSrc(src);
      }
    }
  }, [calculateSize, frameSrc, oldSrc, props.dataTarget, props.internal, props.src, src]);

  let filterCode;
  if (props.filter) {
    filterCode = _.get(props, 'filter', '6464646464646432');
  } else {
    filterCode = _.get(entity, 'style.filter.code', '6464646464646432');
  }

  // eslint-disable-next-line no-unused-vars
  function toDataUrl(url, callback) {
    var xhr = new XMLHttpRequest();
    xhr.onload = function() {
      var reader = new FileReader();
      reader.onloadend = function() {
        callback(reader.result);
      };
      reader.readAsDataURL(xhr.response);
    };
    xhr.open('GET', generateImageLink(url, authToken));
    // xhr.setRequestHeader('authToken', authToken)
    xhr.responseType = 'blob';
    xhr.send();
  }

  const imageColors = url => {
    // eslint-disable-next-line no-undef
    const getColors = require('get-image-colors');
    const checkUrl = imageColorsState.length > 0 && _.find(imageColorsState, { url: url });
    if (!checkUrl) {
      getColors(generateImageLink(url, authToken)).then(colors => {
        const imageColors = [];
        colors.forEach(color => {
          imageColors.push(color.hex());
        });
        dispatch(designActions.addNewColorState({ pageId: props.pageId, url: url, colors: imageColors }));
      });
    }
  };

  const mediaLoaded = e => {
    if (type === 'Image') {
      imageColors(src);
    }
    if (!thumbnailRef.current) {
      calculateSize();
    }
    e.target.style = '';
    thumbnailRef.current && (thumbnailRef.current.style.display = 'none');
    setImageLoaded(true);
    // thumbnailRef.current.remove();
  };
  return (
    <div className="fullWH overflowHidden">
      {src && (
        <div className="MovImgParent">
          <div className="fullWH flipper" style={_.get(entity, 'style.flip', { transform: 'scale(1)' })}>
            <div
              className="MovImgHolder holder fullWH"
              style={_.get(entity, 'style.inner', mediaSize)}
              type={type}
              id={`E${props.dataTarget}`}
            >
              <div className="fullWH ">
                {!imageLoaded && (
                  <img
                    alt=""
                    draggable={false}
                    ref={thumbnailRef}
                    src={generateImageLink(
                      type === 'Image'
                        ? src.replace('screen', 'thumbnail')
                        : src.replace('screen', 'frame'),
                      authToken,
                    )}
                    // onLoad={imageLoad}
                  />
                )}
                {type === 'Image' ? (
                  filterCode === '6464646464646432' ? (
                    <PureImage src={authenticatedSrc} onLoad={mediaLoaded} />
                  ) : (
                    <FilterImage
                      src={authenticatedSrc}
                      entityId={props.dataTarget}
                      style={_.get(entity, 'style.inner', props.style)}
                      filter={filterCode}
                      id={src}
                      onLoad={mediaLoaded}
                      pageSize={props.pageSize}
                    />
                  )
                ) : (
                  <Video
                    key={`c_v_${props.entityId}`}
                    playsInline
                    entityId={props.entityId}
                    data={_.get(entity, 'data')}
                    type={type}
                    style={{ display: 'none', position: 'absolute' }}
                    src={authenticatedSrc}
                    onLoadedData={mediaLoaded}
                  />
                )}
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

Media.propTypes = {
  entityId: PropTypes.number,
  pageId: PropTypes.number,
  type: PropTypes.string,
  src: PropTypes.string,
  droppable: PropTypes.bool,
  internal: PropTypes.bool,
  entity: PropTypes.object,
  filter: PropTypes.object,
  parentSize: PropTypes.object,
  style: PropTypes.object,
  pageSize: PropTypes.object,
  dataTarget: PropTypes.string,
  area: PropTypes.string,
  background: PropTypes.bool,
};

const VImage = props => {
  const entity = useSelector(state => state.design.entitiesState[props.entityId]);
  const {
    'transform-origin': legacyTransformOrigin,
    ...masterStyle
  } = _.get(entity, 'style.master', {});

  if (props.internal) {
    return <Media {...props} />;
  } else {
    return (
      <div
        id={`_${props.entityId}_`}
        data-type="Media"
        data-lock={_.get(entity, 'lock')}
        style={{
          ...masterStyle,
          transformOrigin: masterStyle.transformOrigin || legacyTransformOrigin,
        }}
        className="moveable rSable"
        data-target={props.dataTarget}
        data-page={props.pageId}
      >
        <Droppable internal pageId={props.pageId} entityId={props.entityId} acceptList={['Image', 'Video']}>
          <Media {...props} />
        </Droppable>
      </div>
    );
  }
};

VImage.propTypes = {
  entityId: PropTypes.number,
  pageId: PropTypes.number,
  type: PropTypes.string,
  src: PropTypes.string,
  droppable: PropTypes.bool,
  internal: PropTypes.bool,
  entity: PropTypes.object,
  filter: PropTypes.object,
  parentSize: PropTypes.object,
  style: PropTypes.object,
  pageSize: PropTypes.object,
  dataTarget: PropTypes.string,
};

export default VImage;
